import React, { FC } from 'react'
import './group-banner.css'

// COMPONENTS
import * as Icons from '@icons'

// UTILITIES
import { flatten } from '@utils/string-helper'
import { priceFormatter } from '@utils/number-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    isOrganizer?: boolean,
    isMerchant?: boolean,
    isGroupMember?: boolean,
    group: Group,
    groupStatus?: "active" | "completed" | "canceled" | "finalized" | "pending"
    isLocked?: boolean
    participantPledgeClosed?: boolean
}

const GroupBanner: FC<Props> = (props) => {
    const { className: classProp, isOrganizer, isMerchant, isGroupMember, group, groupStatus, isLocked, participantPledgeClosed, ...divProps } = props
    const className = flatten('group-banner', classProp)

    if (groupStatus === 'active' && isLocked)
        return (
            <div className={className} {...divProps}>
                {(!isGroupMember || isOrganizer || isMerchant)
                    ? <h1>{group.title}</h1>
                    : (
                        <div className='flex flex-col gap-2.5'>
                            <h1>{group.title}</h1>
                            {!participantPledgeClosed
                                ? <h4 className='text-gray-500'>Available Funds: {priceFormatter.format(((group.collectedAmount || 0) - (group.spendAmount || 0)) / 100)}</h4>
                                : <h4 className='text-red-600'><strong>You Have Left This Group</strong></h4>
                            }
                        </div>
                    )}
            </div>
        )
    else if (groupStatus === 'completed' || groupStatus === 'finalized')
        return (
            <div className={flatten(className, 'completed')} {...divProps}>
                <div style={{ position: 'relative' }}>
                    <h1>{group.title}</h1>
                    <div className="bubble-xxxsml checkmark flex items-center justify-center">
                        <Icons.CheckSmall tint="var(--splitcard-white)" width="5em" height="5em" />
                    </div>
                </div>
            </div>
        )
    else return (
        <div className={className} {...divProps}>
            <h1>{group.title}</h1>
        </div>
    )
}

export default GroupBanner
